import * as occlTemplates from './occl';
import * as tefOneTemplates from './tefOne';

export const templates = {
  occl: occlTemplates,
  tefOne: tefOneTemplates as unknown as typeof occlTemplates,
};

export type TemplatesType = typeof tefOneTemplates;
export type TemplateNames = keyof typeof occlTemplates;
